import { render, staticRenderFns } from "./submit-app-store-confirmation-modal.vue?vue&type=template&id=449b4d2a&"
import script from "./submit-app-store-confirmation-modal.vue?vue&type=script&lang=js&"
export * from "./submit-app-store-confirmation-modal.vue?vue&type=script&lang=js&"
import style0 from "./submit-app-store-confirmation-modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "submit-app-store-confirmation-modal.vue"
export default component.exports